import React from "react"
import Grid from "../shared/grid"
import {} from "../homepage/hero.style"

import {
  StatListContainer,
  StatListItem,
  StatListNumber,
  StatListSmall,
  OverlayStyle,
} from "../shared/stats.style"

export default function HeroStatistics() {
  return (
    <Grid overlayStyle={OverlayStyle}>
      <StatListContainer>
        <StatListItem>
          <StatListNumber>
            2.4<StatListSmall>M</StatListSmall>
          </StatListNumber>
          Searches Anually
        </StatListItem>
        <StatListItem>
          <StatListNumber>
            39<StatListSmall>M</StatListSmall>
          </StatListNumber>
          Sessions Anually
        </StatListItem>
        <StatListItem>
          <StatListNumber>638</StatListNumber>
          Properties Globally
        </StatListItem>
      </StatListContainer>
    </Grid>
  )
}
